'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.component('mdi-white-balance-sunny-icon', {
  template: '<svg :class="[\'mdi-icon\', className]" :width="width" :height="height" :viewBox="viewBox"><path  d="M 3.54769,18.5352L 4.9617,19.9502L 6.75669,18.1552L 5.34271,16.7412M 10.9997,22.4482C 11.3157,22.4502 12.9997,22.4482 12.9997,22.4482L 12.9997,19.4982L 10.9997,19.4982M 11.9997,5.49817C 8.68569,5.49817 5.9997,8.18416 5.9997,11.4982C 5.9997,14.8112 8.68569,17.4982 11.9997,17.4982C 15.3127,17.4982 17.9997,14.8112 17.9997,11.4982C 17.9997,8.18416 15.3127,5.49817 11.9997,5.49817 Z M 19.9997,12.4982L 22.9997,12.4982L 22.9997,10.4982L 19.9997,10.4982M 17.2417,18.1552L 19.0367,19.9502L 20.4507,18.5352L 18.6557,16.7412M 20.4507,4.46117L 19.0367,3.04616L 17.2417,4.84116L 18.6557,6.25516M 12.9997,0.548162L 10.9997,0.548162L 10.9997,3.49817L 12.9997,3.49817M 3.99971,10.4982L 0.999705,10.4982L 0.999705,12.4982L 3.99971,12.4982M 6.75669,4.84116L 4.9617,3.04616L 3.54769,4.46117L 5.34271,6.25516L 6.75669,4.84116 Z "/></svg>',
  props: {
    className: [Object, Array, String],
    width: {
      type: Number,
      'default': 24
    },
    height: {
      type: Number,
      'default': 24
    },
    viewBox: {
      type: String,
      'default': '0 0 24 24'
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/mdi-vue/WhiteBalanceSunnyIcon.js
// module id = cT28
// module chunks = 0